<template>
    <v-container fluid>
        <div class="computers">
            <v-card v-for="computer in computers" :key="computer.id" flat class="item"
                    :to="{ name: 'computers.view', params:{id: computer.id} }">
                <v-card-text class="pa-1 px-0" :class="classByStatus(computer.status_id)">
                    <div :class="computer.status_color" class="subtitle-1 font-weight-bold pb-0">
                        {{ computer.code }}
                    </div>
                    <!--<div :class="computer.status_color"-->
                    <!--v-show="computer.status_id !== computer.computed_status_id">*-->
                    <!--</div>-->

                    <!--<div class="caption">-->
                    <!--{{ computer.gpus.length }} x {{ computer.gpus[0].component_code }}-->
                    <!--</div>-->

                    <div class="caption">
                        <!--:class="classByStatus(computer.status_id)"  x {{ computer.status_name }}  -->
                        {{ computer.hash_rate }}/{{ computer.excepted_hash_rate }}, {{ computer.hash_rate_percent }}%,
                        {{ computer.gpus.length }}x
                    </div>
                </v-card-text>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {mapGetters, mapState} from "vuex";

    export default {
        name: 'Grid',
        data: () => ({
            polling: null,
        }),
        computed: {
            ...mapGetters('computers', {
                computers: 'list',
            }),
            ...mapGetters('statuses', {
                classByStatus: 'styleClass',
            }),
            ...mapState({
                statuses: state => state.statuses.items,
            }),
        },
        // methods: {
        //     pollData() {
        //         this.$store.dispatch('computers/load');
        //         this.polling = setInterval(() => {
        //             this.$store.dispatch('computers/load')
        //         }, 50000)
        //     }
        // },
        // beforeDestroy() {
        //     clearInterval(this.polling)
        // },
        // created() {
        //     this.pollData()
        // }
    }
</script>
<style>
    .computers {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
        grid-gap: 5px;
        text-align: center;
    }
</style>
